import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StationType } from 'Services/api/v2';
import { selectStationAndCenterZoom, selectedStationSelector } from './mapSlice';

export default function useMapSelectedStation() {
  const dispatch = useDispatch();
  const selectedStation = useSelector(selectedStationSelector);

  const selectStation = React.useCallback((station: StationType) => {
    dispatch(selectStationAndCenterZoom(station));
  }, [dispatch]);

  return {
    selectedStation,
    selectStation,
  };
}
